// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './PopupEmptyElementListPlaceholder.scss';

const PopupEmptyElementListPlaceholder = (props) => {
    const { className, children, img, tip } = props;

    return (
        <div className={classNames('PopupEmptyElementListPlaceholder', className, { 'has-children': children })}>
            {img}
            <p className="tip">{tip}</p>
            {children}
        </div>
    );
};

PopupEmptyElementListPlaceholder.propTypes = {
    className: PropTypes.string,
    img: PropTypes.object,
    tip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default PopupEmptyElementListPlaceholder;
